import InsperaModal from './InsperaModal';

export default InsperaModal;
